import { render, staticRenderFns } from "./generic-nav.vue?vue&type=template&id=88225860&scoped=true"
import script from "./generic-nav.vue?vue&type=script&lang=js"
export * from "./generic-nav.vue?vue&type=script&lang=js"
import style0 from "./generic-nav.vue?vue&type=style&index=0&id=88225860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88225860",
  null
  
)

export default component.exports